import styled from 'styled-components';

export const Text = styled.p`
  color: ${({ theme }) => theme.palette.common.black};
  margin: 0;
  padding: 0;
`;
